module.exports = __webpack_public_path__ + "img/deluxe-vehicles-filter-toyota.d5f1e28b.png";